import React from "react";
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogFooter,
} from "./ui/dialog";
import { Button } from "./ui/button";
import { AlertCircle } from "lucide-react";
import { useTranslation } from "react-i18next";

interface AuthErrorDialogProps {
  open: boolean;
  onConfirm: () => void;
}

const AuthErrorDialog: React.FC<AuthErrorDialogProps> = ({ open, onConfirm }) => {
  const { t } = useTranslation();

  return (
    <Dialog open={open} onOpenChange={() => {}}>
      <DialogContent className="bg-white max-w-md w-full rounded-lg shadow-lg">
        <DialogHeader>
          <DialogTitle className="flex items-center gap-2">
            <AlertCircle className="w-5 h-5 text-red-600" />
            <span className="text-lg text-[#13161A] font-semibold">
              {t("session_expired_title")}
            </span>
          </DialogTitle>
        </DialogHeader>

        <div className="text-sm text-[#4A5364] py-4">
          <p>{t("session_expired_message")}</p>
        </div>

        <DialogFooter className="flex justify-end gap-2">
          <Button
            onClick={onConfirm}
            className="bg-[#105BDB] text-white hover:bg-[#0055C4] active:bg-[#0049AE] px-6 py-2 text-base font-normal rounded-lg"
          >
            {t("close_session")}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};

export default AuthErrorDialog;
